<template>
    <div>
        <div id="GetMagentoOrderBtn" @click="GetMagentoData">少年リック注文データ</div>
    </div>

    <div id="MagentoOdersTable">
        <div class="MagentoOrder">
            <div class="MagentoOrderTableHeader" @click="ToggleDetails">
                <div>ID</div>
                <div>ストア名前</div>
                <div>ステータス</div>
                <div>注文売上</div>
                <div>日付</div>
            </div>
        </div>
        <MagentoOrder v-for="order in CurrentOrders" :key="order.increment_id" :-order-data="order" />
    </div>
    <div v-if="CurrentOrders.length > 0">
        <div>{{ this.SearchCriteria.current_page + 1 }} / {{ TotalPageCount }}</div>
    </div>
</template>

<script>
import axios from 'axios';
import MagentoOrder from '@/components/MagentoOrder.vue';

export default{
    components:{
        MagentoOrder,
    },
    computed:{
        TotalPageCount()
        {
            return Math.ceil(this.TotalOrderCount / this.SearchCriteria.page_size);
        }
    },
    methods:{
        async GetMagentoData()
        {
            const result = await axios.get(`${process.env.VUE_APP_BACKEND_URL}magento`)
            .then( async (response) => {
                return response.data;
            })
            .catch(error =>{
                console.log('MAGENTO ERROR', error);
                return null;
            });
            
            console.log('MAGENTO RESULT', result);

            this.CurrentOrders = result.items;
            this.SearchCriteria = result.search_criteria;
            this.TotalOrderCount = result.total_count;
        }
    },
    data(){
        return{
            CurrentOrders: [],
            SearchCriteria: {
                filter_groups: [],
                page_size: 20,
                current_page: 0
            },
            TotalOrderCount: 0,
        }
    }
}
</script>

<style>
#GetMagentoOrderBtn
{
    background-color: rgb(206, 36, 36);
    color: white;
    display: inline-block;
    border-radius: 8px;
    padding: 7px 15px;
    cursor: pointer;
    border: 1px solid rgb(158, 15, 15);
    box-shadow: 2px 2px 8px 2px rgba(50,50,50,0.5);
}

#GetMagentoOrderBtn:hover
{
    background-color: rgb(173, 37, 37);
}

#MagentoOdersTable
{
    margin-top: 20px;
}

.MagentoOrderTableHeader
{
    display: flex;
    background-color: orange;
    color: white;
    line-height: 2;
    font-size: 1rem;
    text-align: center;
    font-weight: bold;

    div:first-child {
        width: 75px;
        text-align: center;
        flex: unset;
    }

    div {
        border-right: 2px dotted white;
    }

    div:nth-child(2) {
        text-align: left;
        padding-left: 10px;
        flex: 1;
    }

    div:nth-child(3) {
        width: 175px;
        flex: unset;
    }

    div:nth-child(4) {
        width: 100px;
        flex: unset;
    }

    div:last-child {
        border: none;
        width: 100px;
        flex: unset;
    }
}
</style>